import { useState } from "react";
import ExotelInAppCallSheet from "../components/calls/ExotelInAppCallSheet";
import { startExotelPhoneCall } from "../utils/exotelPhoneCall";
import { showToast } from "../utils/toast";

export function useExotelVoiceCall() {
  const [busy, setBusy] = useState(false);
  const [inApp, setInApp] = useState(null);

  async function placeCall({
    calleeUserId,
    caregiverId,
    marketplace = false,
    peerName,
    peerPhotoUrl,
  } = {}) {
    if (busy) return null;
    setBusy(true);
    try {
      const result = await startExotelPhoneCall({ calleeUserId, caregiverId, marketplace });
      if (result.mode === "webrtc") {
        setInApp({
          sessionId: result.session?.id,
          accessToken: result.accessToken,
          appUserId: result.appUserId,
          peerName: peerName || "Caregiver",
          peerPhotoUrl: peerPhotoUrl || "",
        });
      } else if (result.mode === "tel") {
        if (result.exoPhone) {
          window.location.href = `tel:${result.exoPhone}`;
        }
        showToast.success(
          result.message ||
            "We opened your dialer with a private number. Press the green call button to connect."
        );
      } else if (result.mode === "click2call") {
        showToast.success(
          result.message || "We're calling your phone now. Please answer to connect."
        );
      }
      return result;
    } finally {
      setBusy(false);
    }
  }

  const inAppCallSheet = inApp ? (
    <ExotelInAppCallSheet {...inApp} onClose={() => setInApp(null)} />
  ) : null;

  return {
    callBusy: busy,
    placeCall,
    inAppCallSheet,
  };
}
